import { __ } from '@wordpress/i18n';
import { useSelect, useDispatch } from '@wordpress/data';
import { useBlockProps, InnerBlocks, InspectorControls, BlockControls } from '@wordpress/block-editor';
import { PanelBody, ToolbarButton } from '@wordpress/components';
import './editor.scss';
const ALLOWED_BLOCKS_CONTAINER = ['vayu-blocks/image', 'vayu-blocks/pin'];
const PIN_TEMPLATE = [
    ['vayu-blocks/pin', { x: 50, y: 50 }], // Default pin block
];

export default function Edit({ attributes, setAttributes, clientId, uniqueId }) {
    
    const { id } = attributes;

    if (!attributes.uniqueId) {
        setAttributes({ uniqueId: clientId });
    }

    if (!id) {
        setAttributes({ id: clientId });
    }

    // ******************* Add and Remove Pin Code Start ************************* 
    const { insertBlock, removeBlocks } = useDispatch('core/block-editor');

    // Fetch all `image` blocks within the `image-hotspot` block
    const imageBlocks = useSelect(
        (select) => select('core/block-editor').getBlocks(clientId).filter((block) => block.name === 'vayu-blocks/image'),
        [clientId]
    );

    // Function to add a pin to the first available `image` block
    const handleAddPin = () => {
        if (imageBlocks.length === 0) {
            // Notify if no `image` blocks are available
            notice.error(__('No image blocks available to add a pin.', 'vayu-blocks'));
            return;
        }

        const firstImageBlockId = imageBlocks[0].clientId; // Get the first `image` block
        const newPinBlock = wp.blocks.createBlock('vayu-blocks/pin', { x: 50, y: 50 }); // Default pin block
        insertBlock(newPinBlock, undefined, firstImageBlockId); // Insert the pin into the first image block
    };

    // Function to remove all `pin` blocks inside all `image` blocks
    const handleRemoveAllPins = () => {
        const pinBlocks = imageBlocks.flatMap((imageBlock) => 
            imageBlock.innerBlocks.filter((innerBlock) => innerBlock.name === 'vayu-blocks/pin')
        );

        if (pinBlocks.length) {
            const pinBlockIds = pinBlocks.map((pinBlock) => pinBlock.clientId);
            removeBlocks(pinBlockIds, false); // Remove all pins
        }
    };

    // Get the total count of `pin` blocks across all `image` blocks
    const childPinsCount = useSelect(
        (select) =>
            imageBlocks.reduce(
                (count, imageBlock) =>
                    count + imageBlock.innerBlocks.filter((innerBlock) => innerBlock.name === 'vayu-blocks/pin').length,
                0
            ),
        [imageBlocks]
    );

    const blockProps = useBlockProps({
        id: attributes.uniqueId,
        className: 'vayu-hots-wrapper',
    });


    return (
        <>

            <BlockControls>
                <ToolbarButton onClick={handleAddPin} icon="plus" label={__('Add Pin', 'vayu-blocks')} >
                { __( 'Add Pointer', 'vayu-blocks' ) }
                 
                 </ToolbarButton>
                
                {/* Remove All Pins Button */}
                {/* <ToolbarButton
                    onClick={handleRemoveAllPins}
                    icon="trash"
                    label={__('Remove All Pins', 'vayu-blocks')}
                    disabled={childPinsCount === 0} // Disable if no pins exist
                >
                    {__('Remove All Pins', 'vayu-blocks')}
                </ToolbarButton> */}
                
            </BlockControls>

            <InspectorControls>
                <PanelBody title={__(' ', 'vayu-blocks')}>
                    <p>{__('The Pin block supports drag-and-drop, allowing users to easily select, drag, and place pins onto a image.', 'vayu-blocks')}</p>
                </PanelBody>
            </InspectorControls>

            <div {...blockProps}>
                {/* Main Container Block */}
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS_CONTAINER}
                    template={[
                        ['vayu-blocks/image', { className: 'vayu-hots-main-image-block',
                            overlayshow: true,
                            overlayOpacity: 1,
                            overlayOpacityhvr: 1,
                            opacity: 1
                         }, [['vayu-blocks/pin', { x: 50, y: 50 }],]],
                        // ['vayu-blocks/pin', { x: 50, y: 50 }], // Pin placed by default
                    ]}
                    
                />
            </div>
        </>
    );
}
